import isEqual from "lodash/isEqual";
import { SourceItem } from "../../shared/models/source-item.model";
import { buildCartItem, loadCart, saveCart } from "../../utils/cart.utils";
import { useCallback } from "react";
import { useSiteContext } from "../SiteContext";
import { useFileContext } from "../FileContext";
import { useSystemPropertiesFilter, useValidityFilter } from "../FilterContext";

// Adds the current file to the cart
export const useRemoveFromCart = (): (() => void) => {
    const { siteState } = useSiteContext();
    const { fileState } = useFileContext();
    const validity = useValidityFilter();
    const system = useSystemPropertiesFilter();

    return useCallback(() => {
        const cart = loadCart(siteState.site?.name || "unknown");
        if (fileState.path) {
            const item = buildCartItem(fileState.path, fileState.metadata, validity || "", system || {});
            if (item) {
                const index = cart.findIndex((cartItem: SourceItem) => {
                    return isEqualItems(cartItem, item);
                });
                if (index > -1) {
                    const newcart: Array<SourceItem> = [...cart];
                    newcart.splice(index, 1);
                    saveCart(newcart, siteState.site?.name || "unknown");
                }
            }
        }
    }, [fileState.path, siteState.site?.name, validity, system, fileState.metadata]);
};

export const useRemoveFromCartEnabled = (): (() => boolean) => {
    const { fileState } = useFileContext();
    const { siteState } = useSiteContext();
    const validity = useValidityFilter();
    const system = useSystemPropertiesFilter();

    return useCallback((): boolean => {
        let enabled = false;
        const cart = loadCart(siteState.site?.name || "unknown");
        if (fileState.path) {
            const item = buildCartItem(fileState.path, fileState.metadata, validity || "", system || {});
            if (item) {
                enabled = !!cart.find((cartItem: SourceItem) => {
                    return isEqualItems(cartItem, item);
                });
            }
        }

        return enabled;
    }, [fileState.path, siteState.site?.name, validity, system, fileState.metadata]);
}

function isEqualItems(item1: SourceItem, item2: SourceItem): boolean {
    return item1.value === item2.value
        && isEqual(item1.props.system.lang, item2.props.system.lang)
        && isEqual(item1.props.system.edition, item2.props.system.edition)
        && isEqual(item1.props.validity, item2.props.validity);
}